module.exports = __webpack_public_path__ + "img/744.0b0c3fb4.jpg";